/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GCPRegionsEnum } from './gCPRegionsEnum';


export interface GcpSecretResponse { 
    /**
     * Name/Key of a secret.
     */
    name: string;
    region_id: GCPRegionsEnum;
    /**
     * Version of a secret.
     */
    version: string;
    /**
     * Creation timestamp
     */
    create_time: Date;
}
export namespace GcpSecretResponse {
}


